export const buildAiFieldCellKey = (
  documentHandlerId: string,
  fieldId: string,
): string => `${documentHandlerId}:${fieldId}`;

export const parseAiFieldCellKey = (
  key: string,
): { documentHandlerId: string; fieldId: string } => {
  const separatorIndex = key.indexOf(':');
  if (separatorIndex === -1) {
    return { documentHandlerId: '', fieldId: key };
  }

  return {
    documentHandlerId: key.slice(0, separatorIndex),
    fieldId: key.slice(separatorIndex + 1),
  };
};
